import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import classes from './changePasswordModal.module.scss';
import { getChangePasswordRequest } from '../../../../store/actions/team';
import accountHelpers from '../../../../utils/accountHelpers';
import AttentionModal from '../../../_common/Modal/AttentionModal/AttentionModal';

function TeamChangePasswordModal({
  onClose, userId, isOpen, close,
}) {
  const dispatch = useDispatch();

  const [saveLoading, setSaveLoading] = useState(false);

  const requestData = {
    userId: accountHelpers.getUser(),
    targetUserId: userId,
  };

  const changePasswordClick = async () => {
    setSaveLoading(true);

    const data = await dispatch(getChangePasswordRequest(requestData));

    if (data.status === 'ok') {
      onClose();
    }

    setSaveLoading(false);
  };

  return (
    <div className={classes.modal}>

      <AttentionModal
        isOpen={isOpen}
        onClose={close}
        title="Are you sure you want to reset this user's password? "
        zIndex={31}
        onSave={changePasswordClick}
        loading={saveLoading}
      />

    </div>
  );
}

TeamChangePasswordModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default TeamChangePasswordModal;
